<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">{{title}}</span>
      <span class="zn-text-grey">{{subtitle}}</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="font-size:16px;padding-bottom:10px;color:#444;">
        当前公司：{{company.公司名称}}(简称:{{company.简称}})
      </div>
      <component
        v-if="company._id"
        :is="activeComponent"
        ref="content"
        :company="company"
        :item="item"
      ></component>
    </div>
    <div v-if="hasBtn()" class="zn-template-submit" @click="gotoCompany">进入详情</div>
  </div>
</template>
<script>
import CateRenzhi from './CompanyInfo/Cate.vue'
import AlphaRenzhi from './CompanyInfo/Alpha.vue'
import Money from './CompanyInfo/Money.vue'
import Leader from './CompanyInfo/Leader.vue'
import Sankey from './CompanyInfo/Sankey.vue'
import Intro from './CompanyInfo/Intro.vue'
import Recommend from './CompanyInfo/Recommend.vue'
import Gou from './CompanyInfo/Gou.vue'
import Address from './CompanyInfo/Address.vue'
export default {
  components: {CateRenzhi, AlphaRenzhi, Money, Sankey, Leader, Intro, Recommend, Gou, Address},
  props: {
    item: Object,
  },
  data() {
    return {
      titleMap: {
        公司职能模块认知: { title: '职能模块认知', subtitle: '', component: 'CateRenzhi' },
        公司阿尔法认知: { title: '阿尔法认知', subtitle: '', component: 'AlphaRenzhi' },
        公司薪酬职级: { title: '薪酬职级', subtitle: '如果要编辑，请进入详情', component: 'Money', activeTab: 'CompanySalary' },
        公司高管: { title: '公司高管', subtitle: '如果要编辑，请进入详情', component: 'Leader', activeTab: 'CompanyRadishes' },
        人才流入流出: { title: '人才流入流出', subtitle: '', component: 'Sankey' },
        客户公司介绍及高管: { title: '客户公司介绍及高管', subtitle: '如果要编辑，请进入详情', component: 'Intro', activeTab: 'ClientPic' },
        推荐须知: { title: '推荐须知', subtitle: '点击进入详情，可以查看面试相关详情', component: 'Recommend', activeTab: 'Interview' },
        客户沟通备注: { title: '客户沟通备注', subtitle: '填写后点击保存后会保存到公司', component: 'Gou' },
        面试地址: { title: '面试地址', subtitle: '想要编辑，请点击进入详情，在公司详情里编辑', component: 'Address', activeTab: 'Interview' },
      },
      title: '',
      subtitle: '',
      company: {},
      activeComponent: ''
    }
  },
  methods: {
    async initData() {
      if (this.titleMap[this.item.name]) {
        this.title = this.titleMap[this.item.name].title
        this.subtitle = this.titleMap[this.item.name].subtitle
        this.activeComponent = this.titleMap[this.item.name].component
      } else {
        this.activeComponent = ''
      }
      if (this.item.cid) {
        const res = await app.service('company').getCompany({ _id: this.item.cid })
        if (res.status === 200) {
          this.company = res.result
        } else {
          this.company = {}
        }
        console.log('company', this.company)
      }
      this.$nextTick(()=>{
        if (this.$refs.content && this.$refs.content.initData) {
          this.$refs.content.initData()
        }
      })
    },
    gotoCompany() {
      window.open(`${window.frontend}/#/company/${this.company._id}?tab=${this.titleMap[this.item.name].activeTab}`)
    },
    hasBtn() {
      return (this.titleMap[this.item.name] && this.titleMap[this.item.name].activeTab)
    }
  }
}
</script>
